module.exports = __webpack_public_path__ + "img/2.525c15d2.png";